<div
  class="row"
  (click)="openEmployeeInfoModal()"
>
  <div class="col-3 d-flex align-items-center">
    <base-checkbox
      *ngIf="!isWorkCouncil"
      [isChecked]="!!assignmentListItem?.isSelected"
      (click)="onItemSelect($event)"
    ></base-checkbox>
    <div
      baseTruncate
      [ngClass]="{ 'ms-7': !isWorkCouncil }"
    >
      <span class="fw-bold external-employee-name">
        {{ profileFullName }}
      </span>
      <br />
      <span>{{ assignmentListItem?.mainQualification?.name | baseIsEmpty }}</span>
    </div>
  </div>

  <div class="col">
    <div class="d-flex align-items-center gap-3">
      <base-izs-rating
        *ngIf="!hasWorkCouncilRole"
        [color]="assignmentListItem?.pspBranch?.izsStatus"
        (click)="openIzsInfoModal($event)"
      ></base-izs-rating>
      <div baseTruncate>
        <span>{{ assignmentListItem?.pspBranch?.name | baseIsEmpty }}</span>
        <br />
        <span>{{ assignmentListItem?.pspBranch?.businessAddress?.city | baseIsEmpty }}</span>
      </div>
    </div>
  </div>

  <div
    class="col-2"
    baseTruncate
  >
    <span>{{ assignmentListItem?.customerDepartment?.name | baseIsEmpty }}</span>
    <br />
    <span>{{ assignmentListItem?.customerLocation?.name | baseIsEmpty }}</span>
  </div>

  <div class="col text-truncate">
    <p
      class="mb-0"
      baseTruncate
    >
      <span
        [ngClass]="{
          'operation-date-active': assignmentStatus === intervalStatus.active,
          'operation-date-planned': assignmentStatus === intervalStatus.planned,
          'operation-date-ended': assignmentStatus === intervalStatus.ended
        }"
        class="fw-bold operation-date-planned"
        >{{ 'dateTime.startFrom' | translate }} {{ assignmentListItem?.startDate | baseIsEmpty | baseFormatDate }}
      </span>
      <br />
      <span
        *ngIf="assignmentStatus === intervalStatus.active || assignmentStatus === intervalStatus.ended"
        [ngClass]="{
          'operation-date-active': assignmentStatus === intervalStatus.active,
          'operation-date-ended': assignmentStatus === intervalStatus.ended
        }"
        class="fw-bold"
      >
        <span
          >{{ 'dateTime.to' | translate | lowercase }} {{ assignmentListItem?.endDate | baseFormatDate | baseIsEmpty }}
        </span>
        <span *ngIf="assignmentListItem?.unlimited"><br />({{ 'inquiry.unlimitedUntilMLPShort' | translate }})</span>
      </span>
    </p>

    <div
      *ngIf="assignmentListItem?.createdBy as createdBy"
      [ngbTooltip]="createdByTooltipTemplate"
      [tooltipContext]="{ value: createdBy }"
      class="fs-8 text-dark-gray text-truncate"
    >
      {{ 'operations.manual' | translate }}
      <span class="d-inline-block"> <i class="fa-solid fa-info-circle"></i></span>
    </div>

    <p
      *ngIf="assignmentListItem?.assignmentCancelation?.cancelationDate"
      class="fw-bold text-danger mb-0"
      baseTruncate
    >
      {{ 'operations.cancelledOn' | translate }}
      {{ assignmentListItem?.assignmentCancelation?.cancelationDate | baseFormatDate }}
    </p>
  </div>

  <div
    class="col-1"
    baseTruncate
  >
    {{ assignmentListItem?.mlp | baseFormatDate | baseIsEmpty }}
  </div>

  <div
    class="col-1"
    baseTruncate
  >
    {{ assignmentListItem?.ep | baseFormatDate | baseIsEmpty }}
  </div>

  <div
    class="col-1"
    baseTruncate
    data-test="agreed-weekly-hours"
  >
    {{
      agreedWeeklyHours
        ? ('operations.agreedWorkingTime.weeklyShort' | translate: { hours: agreedWeeklyHours })
        : ('' | baseIsEmpty)
    }}
  </div>

  <div class="col d-flex justify-content-end gap-2">
    <ng-container *ngIf="!isWorkCouncil">
      <ng-container *ngIf="assignmentListItem && assignmentListItem.contract">
        <base-sign-contract-animated-status-button
          *ngIf="
            assignmentListItem.contract?.type === contractSigningType.DIGITAL &&
              (assignmentListItem.contract?.signatures?.statusCustomer === signingStatusBySide.in_queue ||
                assignmentListItem.contract?.signatures?.statusCustomer === signingStatusBySide.error ||
                assignmentListItem.contract?.signatures?.statusPsp === signingStatusBySide.error);
            else standardButton
          "
          [contract]="assignmentListItem.contract"
          (click)="openSignContractsModal($event)"
        ></base-sign-contract-animated-status-button>
        <ng-template #standardButton>
          <base-button
            color="dark"
            icon="fa-solid fa-file-signature"
            [size]="buttonSizes.md"
            [iconSize]="buttonSizes.md"
            [stateClass]="statusButtonBorder"
            [ngbTooltip]="signStatusTooltip"
            [permissionBased]="true"
            (btnClick)="openSignContractsModal($event)"
          ></base-button>
        </ng-template>
      </ng-container>
      <base-button
        color="dark"
        icon="fa-solid fa-calendar-clock"
        [size]="buttonSizes.md"
        [iconSize]="buttonSizes.md"
        tooltip="externalEmployees.timeRecordings.tooltip"
        (btnClick)="openTimeRecording($event)"
      ></base-button>
    </ng-container>
  </div>
</div>

<ng-template #employeeInfoModalBody>
  <base-customer-employee-info-modal
    [(currentTab)]="currentTab"
    [modalRef]="modalRef"
  ></base-customer-employee-info-modal>
</ng-template>

<ng-template #addSignSelectionPopup>
  <base-sign-contract-selection
    [modalRef]="addSignModalRef"
    [(signingType)]="signingType"
    [currentAssignment]="customerAssignment"
    (signingTypeChange)="onSignTypeChange($event)"
  ></base-sign-contract-selection>
</ng-template>

<ng-template #addSignPopup>
  <base-sign-contracts-sign [modalRef]="digitalSignModalRef"></base-sign-contracts-sign>
</ng-template>

<ng-template #signStatusTooltip>
  <base-sign-contract-status-tooltip
    [contract]="assignmentListItem?.contract"
    [isPsp]="false"
  ></base-sign-contract-status-tooltip>
</ng-template>

<ng-template
  #createdByTooltipTemplate
  let-value="value"
>
  <div class="text-start">
    <div>{{ value.userName }}</div>
    <div>{{ value.createdAt | baseFormatDate: true:false:('dateTime.hour' | translate) }}</div>
  </div>
</ng-template>
